<script>
  import {styleVars} from '/helper'
  import Card from '/components/Atoms/Card.svelte'
  import Link from '/components/Atoms/Link.svelte'
  import IconList from '/components/Icons/IconList.svelte'
  import { _ } from 'svelte-i18n'

  export let entries, flow = false, noheader = false, showmore = false

  // console.log(entries)

  const getImages = entry => {
    let containImage = entry?.backgroundImage?.[0]?.url
    let coverImage = entry?.collection?.[0]?.mediaImage?.[0]?.url
    //console.log(entry, containImage, coverImage)
    return {
      containImage,
      coverImage
    }
  }

  const getSubtitle = entry => {
    if (entry?.textMediaCategory) {
      return entry.textMediaCategory
    }
    if (entry?.collection) {
      return "Gallery"
    }
    return null
  }

  entries = entries.map(e => ({...e, ...getImages(e)}))
  
</script>

<Card bgColorKey="beige" {flow} paddingStyle="fromalmanac">
  <div class="container">
    {#if !noheader}
      <h3 class="headline">
        {$_("widgets.almanac.from_the_almanac")}
      </h3>
    {/if}
    {#if false}<slot />{/if}
    <ul>
    {#each entries as entry}
      <li>
        <Link section="almanac" slug={entry.slug}>
          <span class="entry">
            <span 
              class="icon" 
              data-type={entry.typeHandle} 
              class:containImage={!!entry.containImage}
              class:coverImage={!!entry.coverImage}
              style={`--imageContainUrl: url('${entry.containImage}'); --imageCoverUrl: url('${entry.coverImage}')`}
              />
            <span class="content">
              <span class="title">{entry.title}</span>
              {#if getSubtitle(entry)}
                <span class="subtitle">{getSubtitle(entry)}</span>
              {/if}
            </span>
          </span>
        </Link>
      </li>
    {/each}
    </ul>
    {#if showmore}
      <Link to="/almanac" >
        <span class="more">
          <span class="text">{$_("widgets.almanac.see_all_entries")}</span>
          <IconList class="icon"/>
        </span>
      </Link>
    {/if}
  </div>
</Card>

<style lang="scss">
  .container {
    width: 100%;
    text-align: left;
  }
  .headline, .entry {
    margin-bottom: 22px;
    @include media-small {
      margin-bottom: 15px;
    }
  }
  li:last-child {
    margin-bottom:0;
  }
  .headline {
    @include typo-serif-small-caps-28;
    color: $color-red;
  }
  .entry {
    display: flex;

    .content {
      flex: 1;
      place-self: center;

      .title, .subtitle {
        display: block;
      }

      .title {
        @include typo-grotesk-text-24-multistep;
      }

      .subtitle {
        @include typo-grotesk-title-captions-20;
        text-transform: capitalize;
        color: $color-red;
      }
    }

    .icon {
      @include box-shadow;
      display: block;
      box-sizing: border-box;

      width: 90px;
      height: 90px;
      border-radius: 20px; // ?
      margin-right: 15px;

      @include media-small {
        width: 70px;
        height: 70px;
        border-radius: 15px;
      }

      @include media-larger {
        margin-right: 20px;
      }

      background-repeat: no-repeat;
      background-position: center;

      &[data-type="audio"] {
        background-image: url("/assets/icons/audio.svg");
      }
      &[data-type="video"] {
        background-image: url("/assets/icons/video.svg");
        background-position: 54%;
      }
      &.containImage {
        background-size: contain;
        background-image: var(--imageContainUrl);
      }
      &.coverImage {
        background-size: cover;
        background-image: var(--imageCoverUrl);
      }
    }
  }

  .more {
    @include typo-serif-small-caps-28;
    color: $color-red;
    display: flex;
    justify-content: space-between;
    .icon {
      
    }
  }
</style>